// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/assets/vendor/js/bootstrap": 0,
	"assets/vendor/libs/highlight/highlight-github": 0,
	"assets/vendor/css/pages/app-chat": 0,
	"assets/vendor/css/pages/app-calendar": 0,
	"assets/vendor/fonts/tabler-icons": 0,
	"assets/vendor/fonts/fontawesome": 0,
	"assets/vendor/fonts/flag-icons": 0,
	"assets/vendor/libs/typeahead-js/typeahead": 0,
	"assets/vendor/libs/toastr/toastr": 0,
	"assets/vendor/libs/tagify/tagify": 0,
	"assets/vendor/libs/swiper/swiper": 0,
	"assets/vendor/libs/sweetalert2/sweetalert2": 0,
	"assets/vendor/libs/spinkit/spinkit": 0,
	"assets/vendor/css/pages/advanced-wizard": 0,
	"assets/vendor/libs/shepherd/shepherd": 0,
	"assets/vendor/libs/select2/select2": 0,
	"assets/vendor/libs/rateyo/rateyo": 0,
	"assets/vendor/libs/quill/typography": 0,
	"assets/vendor/libs/quill/katex": 0,
	"assets/vendor/libs/quill/editor": 0,
	"assets/vendor/libs/plyr/plyr": 0,
	"assets/vendor/libs/pickr/pickr-themes": 0,
	"assets/vendor/libs/perfect-scrollbar/perfect-scrollbar": 0,
	"assets/vendor/libs/nouislider/nouislider": 0,
	"assets/vendor/css/core": 0,
	"assets/vendor/libs/node-waves/node-waves": 0,
	"assets/vendor/libs/leaflet/leaflet": 0,
	"assets/vendor/libs/jstree/jstree": 0,
	"assets/vendor/libs/jquery-timepicker/jquery-timepicker": 0,
	"assets/vendor/libs/jkanban/jkanban": 0,
	"assets/vendor/libs/highlight/highlight": 0,
	"assets/vendor/libs/fullcalendar/fullcalendar": 0,
	"assets/vendor/libs/flatpickr/flatpickr": 0,
	"assets/vendor/libs/dropzone/dropzone": 0,
	"assets/vendor/css/core-dark": 0,
	"assets/vendor/libs/datatables-select-bs5/select.bootstrap5": 0,
	"assets/vendor/libs/datatables-rowgroup-bs5/rowgroup.bootstrap5": 0,
	"assets/vendor/libs/datatables-responsive-bs5/responsive.bootstrap5": 0,
	"assets/vendor/libs/datatables-fixedheader-bs5/fixedheader.bootstrap5": 0,
	"assets/vendor/libs/datatables-fixedcolumns-bs5/fixedcolumns.bootstrap5": 0,
	"assets/vendor/libs/datatables-checkboxes-jquery/datatables.checkboxes": 0,
	"assets/vendor/libs/datatables-buttons-bs5/buttons.bootstrap5": 0,
	"assets/vendor/libs/datatables-bs5/datatables.bootstrap5": 0,
	"assets/vendor/libs/bs-stepper/bs-stepper": 0,
	"assets/vendor/libs/bootstrap-select/bootstrap-select": 0,
	"assets/vendor/libs/bootstrap-maxlength/bootstrap-maxlength": 0,
	"assets/vendor/libs/bootstrap-daterangepicker/bootstrap-daterangepicker": 0,
	"assets/vendor/libs/bootstrap-datepicker/bootstrap-datepicker": 0,
	"assets/vendor/libs/apex-charts/apex-charts": 0,
	"assets/vendor/libs/animate-on-scroll/animate-on-scroll": 0,
	"assets/vendor/libs/animate-css/animate": 0,
	"assets/vendor/css/theme-semi-dark": 0,
	"assets/vendor/css/theme-semi-dark-dark": 0,
	"assets/vendor/css/theme-raspberry": 0,
	"assets/vendor/css/theme-raspberry-dark": 0,
	"assets/vendor/css/theme-default": 0,
	"assets/vendor/css/theme-default-dark": 0,
	"assets/vendor/css/theme-bordered": 0,
	"assets/vendor/css/theme-bordered-dark": 0,
	"assets/vendor/css/rtl/theme-semi-dark": 0,
	"assets/vendor/css/rtl/theme-semi-dark-dark": 0,
	"assets/vendor/css/rtl/theme-raspberry": 0,
	"assets/vendor/css/rtl/theme-raspberry-dark": 0,
	"assets/vendor/css/rtl/theme-default": 0,
	"assets/vendor/css/rtl/theme-default-dark": 0,
	"assets/vendor/css/rtl/theme-bordered": 0,
	"assets/vendor/css/rtl/theme-bordered-dark": 0,
	"assets/vendor/css/rtl/core": 0,
	"assets/vendor/css/rtl/core-dark": 0,
	"assets/vendor/css/pages/wizard-ex-checkout": 0,
	"assets/vendor/css/pages/ui-carousel": 0,
	"assets/vendor/css/pages/page-user-view": 0,
	"assets/vendor/css/pages/page-profile": 0,
	"assets/vendor/css/pages/page-pricing": 0,
	"assets/vendor/css/pages/page-misc": 0,
	"assets/vendor/css/pages/page-icons": 0,
	"assets/vendor/css/pages/page-help-center": 0,
	"assets/vendor/css/pages/page-faq": 0,
	"assets/vendor/css/pages/page-auth": 0,
	"assets/vendor/css/pages/page-account-settings": 0,
	"assets/vendor/css/pages/cards-advance": 0,
	"assets/vendor/css/pages/app-kanban": 0,
	"assets/vendor/css/pages/app-invoice": 0,
	"assets/vendor/css/pages/app-invoice-print": 0,
	"assets/vendor/css/pages/app-email": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkVuexy"] = self["webpackChunkVuexy"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));